module.exports = __webpack_public_path__ + "img/burger-menu-background.2c1216af.jpg";